export default function CarsMapController(
    $scope,
    $q,
    mapsFactory,
    carsFactory,
    searchData,
    uiGmapGoogleMapApi
) {
    'ngInject';

    const vm = this;
    $scope.companies = searchData.searchResults.matrix.mapCompanies;
    $scope.MarkersWithLabel = [];
    $scope.showMap = false;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        $q.all([
            uiGmapGoogleMapApi,
            getMarkers(searchData.formData.SearchId),
        ]).then(processMarkers);

        watch();
    }

    function watch() {
        $scope.$watch(() => carsFactory.getSearchResults(), refreshData);
    }

    function refreshData(newVal, oldVal) {
        if (!angular.equals(newVal, oldVal)) {
            mapsFactory.getMarkers(newVal.searchId);
        }
    }

    function getMarkers(searchId) {
        return mapsFactory.getMarkers(searchId);
    }

    function processMarkers([, {data}]) {
        const {
            PickUpLatitude: latitude, PickUpLongitude: longitude,
        } = searchData.formData;
        const remappedMarkers = _.map(data, remapMarker);
        $scope.MarkersWithLabel = mapsFactory.composeMarkers(remappedMarkers);
        $scope.cityCenterMarker = mapsFactory.createCityCenterMarker(latitude, longitude);

        mapsFactory.initialize($scope);
    }

    function remapMarker(marker) {
        const {
            Price, ModelName, PickUpAddress, PickUpLatitude, PickUpLongitude,
        } = marker;
        return {
            Price,
            Name: ModelName,
            Address: PickUpAddress,
            Latitude: PickUpLatitude,
            Longitude: PickUpLongitude,
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/cars/controllers/cars-map-controller.js